import { Radio } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import React from 'react';

class SelectableTable extends React.Component {
  state = {
    selectedItem: {},
  };

  handleItemSelect(e, item) {
    this.setState({
      selectedItem: item,
    });

    this.props.onItemSelect(item);
  }

  render() {
    const selectionKey = this.props.selectionKey;
    return (
      <Table style={{ tableLayout: 'auto' }}>
        <TableBody>
          {this.props.dataSource.map(item => {
            const isSelected =
              this.state.selectedItem[selectionKey] === item[selectionKey];
            return (
              <TableRow
                className="selectable__table__row"
                hover
                selected={isSelected}
                onClick={event => this.handleItemSelect(event, item)}
                style={{ cursor: 'pointer' }}
                key={item[selectionKey]}
              >
                <TableCell padding="checkbox" style={{ width: '60px' }}>
                  <Radio color="primary" checked={isSelected} />
                </TableCell>
                <TableCell padding="none" component="th" scope="row">
                  {this.props.generateRowLabel
                    ? this.props.generateRowLabel(item)
                    : item.name}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  }
}

SelectableTable.propTypes = {
  selectionKey: PropTypes.string.isRequired,
  onItemSelect: PropTypes.func.isRequired,
  dataSource: PropTypes.array.isRequired,
};

export default SelectableTable;



// WEBPACK FOOTER //
// ./src/components/Utility/Tables/SelectableTable.jsx